var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgViewSidebarLeftFill = function SvgViewSidebarLeftFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.652 16.583a1.2 1.2 0 0 1-.873-.362 1.2 1.2 0 0 1-.362-.873V4.652q0-.51.362-.873a1.2 1.2 0 0 1 .873-.362h10.696q.51 0 .873.362.363.36.362.873v10.696q0 .51-.362.873a1.2 1.2 0 0 1-.873.362zM8.083 15.5h7.16a.25.25 0 0 0 .177-.08.25.25 0 0 0 .08-.176V4.756a.25.25 0 0 0-.08-.176.25.25 0 0 0-.176-.08h-7.16z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgViewSidebarLeftFill);
export { ForwardRef as ReactComponent };